import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React, {useState} from 'react'
import styled from 'styled-components'

export default function ObieDescriptionPopover() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const isOpen = Boolean(anchorEl)

  const open = (event: React.SyntheticEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget)
  const close = () => setAnchorEl(null)

  const toggle = (event: React.MouseEvent<HTMLElement>) => {
    if (isOpen) {
      close()
      return
    }

    open(event)
  }

  return (
    <>
      <IconButton
        aria-label="about obie"
        size="small"
        onClick={toggle}
        onMouseEnter={open}
        onMouseLeave={close}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <StyledPopover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
        disableScrollLock
        hideBackdrop
      >
        <Description>
          Obie lets you build an AI Hub, a branded space where your attendees
          get AI guidance and content. This integration sends attendees to your
          AI Hub. Nothing is imported into obvio.
        </Description>
      </StyledPopover>
    </>
  )
}

const StyledPopover = styled(Popover)`
  pointer-events: none;
`

const Description = styled(Typography)`
  max-width: 360px;
  padding: ${(props) => props.theme.spacing[4]};
`
